export const FLEET_CAT_IMG_RATIO = '227 / 151';
